//INTERNAL
export const ROUTE_OFFER = '/:id?'
export const ROUTE_NOT_FOUND = '*'
